export const motorProposalStatus = {
  methods: {
    async doMotorProposalStatus(notification) {
      try {
        if (notification && notification.params) {
          const { proposalNo } = notification.params

          // Load the proposal 1st
          this.$router.push({ name: 'motorQuoteQuery', params: { id: proposalNo } })
        }
      } catch (err) {
        this.$snotify.error('An error has been caught while executing this action')
      }
    }
  }
}
